var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalIncome(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1217_65931)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1217_65931",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H22V22H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1217_65931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 6.69982C10.7606 6.69982 11.2691 7.17222 11.2691 7.75496C11.2691 8.33766 10.7606 8.81006 10.1334 8.81006C9.50609 8.81006 8.99756 8.33766 8.99756 7.75496",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 6.69995C9.50609 6.69995 8.99756 6.22755 8.99756 5.64481C8.99756 5.06207 9.50609 4.58967 10.1334 4.58967C10.7606 4.58967 11.2691 5.06207 11.2691 5.64481",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1335 4.2404V9.15942",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5613 4.24048L15.7405 3.55964",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6897 2.36914L13.3705 1.18991",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1335 1.68408V0.322445",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57684 2.36914L6.896 1.18991",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7056 4.24048L4.52637 3.55964",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8149 10.3698H5.75715C5.40304 10.3698 5.11597 10.6569 5.11597 11.011V11.6133C5.11597 11.9674 5.40304 12.2544 5.75715 12.2544H11.8149C12.169 12.2544 12.4561 11.9674 12.4561 11.6133V11.011C12.4561 10.6569 12.169 10.3698 11.8149 10.3698Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8149 12.2545H5.75715C5.40304 12.2545 5.11597 12.5416 5.11597 12.8957V13.498C5.11597 13.8521 5.40304 14.1392 5.75715 14.1392H11.8149C12.169 14.1392 12.4561 13.8521 12.4561 13.498V12.8957C12.4561 12.5416 12.169 12.2545 11.8149 12.2545Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 17.9086H10.7748C10.4206 17.9086 10.1335 18.1956 10.1335 18.5497V19.152C10.1335 19.5061 10.4206 19.7932 10.7748 19.7932H16.8325C17.1866 19.7932 17.4737 19.5061 17.4737 19.152V18.5497C17.4737 18.1956 17.1866 17.9086 16.8325 17.9086Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 16.0241H10.7748C10.4206 16.0241 10.1335 16.3112 10.1335 16.6652V17.2675C10.1335 17.6217 10.4206 17.9087 10.7748 17.9087H16.8325C17.1866 17.9087 17.4737 17.6217 17.4737 17.2675V16.6652C17.4737 16.3112 17.1866 16.0241 16.8325 16.0241Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 19.7931H10.7748C10.4206 19.7931 10.1335 20.0802 10.1335 20.4343V21.0366C10.1335 21.3907 10.4206 21.6777 10.7748 21.6777H16.8325C17.1866 21.6777 17.4737 21.3907 17.4737 21.0366V20.4343C17.4737 20.0802 17.1866 19.7931 16.8325 19.7931Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 15.3827V14.7804C10.1334 14.4263 10.4205 14.1393 10.7745 14.1393H5.75715C5.40308 14.1393 5.11597 14.4263 5.11597 14.7804V15.3827C5.11597 15.7368 5.40308 16.0239 5.75715 16.0239H10.7745C10.4205 16.0239 10.1334 15.7368 10.1334 15.3827Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 17.2675V16.6652C10.1334 16.3111 10.4205 16.0241 10.7745 16.0241H5.75715C5.40308 16.0241 5.11597 16.3111 5.11597 16.6652V17.2675C5.11597 17.6216 5.40308 17.9087 5.75715 17.9087H10.7745C10.4205 17.9087 10.1334 17.6216 10.1334 17.2675Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 19.152V18.5497C10.1334 18.1956 10.4205 17.9086 10.7745 17.9086H5.75715C5.40308 17.9086 5.11597 18.1956 5.11597 18.5497V19.152C5.11597 19.5061 5.40308 19.7932 5.75715 19.7932H10.7745C10.4205 19.7932 10.1334 19.5061 10.1334 19.152Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 21.0366V20.4342C10.1334 20.0802 10.4205 19.7931 10.7745 19.7931H5.75715C5.40308 19.7931 5.11597 20.0802 5.11597 20.4342V21.0366C5.11597 21.3907 5.40308 21.6777 5.75715 21.6777H10.7745C10.4205 21.6777 10.1334 21.3907 10.1334 21.0366Z",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3707 14.1393H10.7747C10.4206 14.1393 10.1335 14.4263 10.1335 14.7805V15.3827C10.1335 15.7369 10.4206 16.0239 10.7747 16.0239H16.8325C17.1866 16.0239 17.4737 15.7369 17.4737 15.3827V14.7805C17.4737 14.4263 17.1866 14.1393 16.8325 14.1393H14.8746",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7261 5.94787C13.3791 4.28167 11.9026 3.02978 10.1334 3.02978C8.10651 3.02978 6.46338 4.6729 6.46338 6.69983C6.46338 8.72675 8.10651 10.3699 10.1334 10.3699C11.9026 10.3699 13.3791 9.11794 13.7261 7.45178",
    stroke: "white",
    strokeWidth: 0.87891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_65931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIncome);
export default __webpack_public_path__ + "static/media/totalIncome.377fa80fdbe8d399e6714dfb3b8105aa.svg";
export { ForwardRef as ReactComponent };